module.exports = __webpack_public_path__ + "img/TC21&26.de199f76.jpg";